<template>
  <div id="wrapper" class="noheader">
    <div class="content">
      <div class="caption">
        <div class="inner">
          <span></span>
          <p>VIP 門診預約</p>
          <span></span>
        </div>
      </div>
      <div class="formBox">
        <form action="javascript:void(0);">
          <p class="txt">預約姓名</p>
          <input
            type="text"
            class="inputBox"
            placeholder="請輸入預約者的真實姓名"
            v-model="reservation.name"
          />
          <p class="txt">手機號碼</p>
          <input
            type="text"
            class="inputBox"
            placeholder="請輸入預約者的聯繫電話"
            v-model="reservation.phone"
          />
          <p class="txt">選擇醫師</p>
          <select v-model="reservation.doctor">
            <option value=" ">=== 請選擇 ===</option>
            <option v-for="doctor in doctors" :key="doctor">
              {{ doctor }}
            </option>
          </select>
          <p class="txt">預計看診日期(此部分須由專人安排)</p>
          <input
            type="text"
            class="inputBox"
            placeholder="請輸入預計看診日期"
            v-model="reservation.date"
          />
          <p class="txt">需求說明</p>
          <textarea
            placeholder="請輸入預約者的看診需求"
            v-model="reservation.memo"
          ></textarea>
          <input
            @click="submit"
            type="submit"
            class="submitBtn"
            value="確認預約"
          />
        </form>
      </div>
    </div>
  </div>

  <modal
    v-if="modal.display"
    @close="
      modal.isShowUnderstand === true
        ? (modal.display = false)
        : $router.replace('/HomePage')
    "
  >
    <template #header>{{ modal.header }}</template>
    <template #body>{{ modal.body }}</template>
  </modal>
</template>

<script>
import api from "../api/index";
export default {
  data() {
    return {
      doctors: [
        "婦產科 李木生醫師",
        "婦產科 李建南醫師",
        "婦產科 李佳珩醫師",
        "婦產科 陳維敏醫師",
        "婦產科 蘇伶瀅醫師",
        "婦產科 張明揚醫師",
        "小兒科 邱彙雅醫師",
        "小兒科 張馨予醫師"
      ],
      modal: {},
      confirm: {}
    };
  },
  computed: {
    reservation() {
      return {
        name: this.$store.state.member.info.name,
        phone: this.$store.state.member.info.phone,
        doctor: "",
        date: "",
        memo: ""
      };
    },
    member() {
      return this.$store.state.member;
    },
    from() {
      return this.$store.state.from;
    }
  },
  methods: {
    submit() {
      switch (true) {
        case this.reservation.name.trim() === "":
          this.modal = {
            display: true,
            header: "提示訊息",
            body: "請輸入預約姓名。",
            isShowUnderstand: true
          };
          return false;
        case this.reservation.phone.trim() === "":
          this.modal = {
            display: true,
            header: "提示訊息",
            body: "請輸入您的手機號碼。",
            isShowUnderstand: true
          };
          return false;
        case this.reservation.doctor.trim() === "":
          this.modal = {
            display: true,
            header: "提示訊息",
            body: "請選擇醫師",
            isShowUnderstand: true
          };
          return false;
        case this.reservation.date.trim() === "":
          this.modal = {
            display: true,
            header: "提示訊息",
            body: "請輸入您預計看診日期",
            isShowUnderstand: true
          };
          return false;
      }
      console.log("預約資訊", this.reservation);
      api.vipReservation
        .create({
          jwt: this.member.jwt,
          reservation: this.reservation
        })
        .then(data => {
          console.log(data);
          this.modal = {
            display: true,
            header: "VIP 門診預約",
            body:
              "已送出預約資訊，後續將有專人與您聯繫安排實際看診時間。我們的聯繫電話為行動電話，還請務必接聽。\n謝謝您! 木生婦幼診所。"
          };
        })
        .catch(error => {
          this.modal = {
            display: true,
            header: "VIP 門診預約",
            body:
              "很抱歉，VIP預約時發生異常，請重新操作或與我們聯繫，造成不便還請見諒。" +
              error
          };
        });
    }
  }
};
</script>
